<template>
    <v-container grid-list-xl>
        <v-layout row wrap>
            <v-flex xs6>
                <h1>Routes</h1>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    @input="updateRows"
                    single-line
                    hide-details
                ></v-text-field>
            </v-flex>
            <v-flex xs6 class="text-right">
                <v-btn color="primary" dark @click="createRouteProcess">Add Route</v-btn>
                <v-btn color="neutral ml-2" dark :to="'/management/routes/archived'">Archived</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="displayRoutes"
                        item-key="`${name} ${id}`"
                        :server-items-length="numDisplayRoutes"
                        :options.sync="options"
                        class="elevation-1">
                        <template v-slot:item.action="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="primary"
                                        @click="openRouteDetails(item)">
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>Route Information</span>
                            </v-tooltip>
                            <v-tooltip top v-if="!item.complete">
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="green"
                                        @click="completeRouteHandler(item)">
                                        mdi-check-circle-outline
                                    </v-icon>
                                </template>
                                <span>Complete Route</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="grey"
                                        @click="archiveRoute(item)">
                                        mdi-archive
                                    </v-icon>
                                </template>
                                <span>Archive Route</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
            <archive-route :toggle="toggleArchive" :show-dialog="archiveDialog" :route="selectedRoute" :incompleteTasks="incompleteTasks"></archive-route>
            <route-details :from-route-details="true" :action-type="detailsType" :toggle="toggleRouteDetails" :show-dialog="routeDetails" :show-remove-task-dialog="removeTaskFromRoute" :show-update-status-dialog="updateTaskStatus" :show-remove-user-dialog="removeUserFromTask" :show-task-details-dialog="editTaskDetails"></route-details>
            <task-details :job-task="selectedDetailsTask" :show-dialog="taskDetailsDialog" :toggle="toggleTaskDetailsDialog"></task-details>
            <unassign-task :show-dialog="removeTaskDialog" :toggle="toggleRemoveTaskDialog" :job-task="selectedDetailsTask"></unassign-task>
            <remove-user-from-task :show-dialog="removeUserDialog" :toggle="toggleRemoveUserDialog" :user="selectedUser"></remove-user-from-task>
            <complete-route :showDialog="completeRouteDialog" :toggle="toggleComplete" :route="selectedRoute"  :incompleteTasks="incompleteTasks"></complete-route>
        </v-layout>
    </v-container>
</template>
<script>
    import ArchiveRoute from '../../../../components/routes/Archive'
    import CompleteRoute from '../../../../components/routes/Complete'
    import RouteDetails from '../../../../components/routes/Details'
    import {mapActions, mapGetters} from 'vuex'
    import UnassignTask from "../../../../components/jobTasks/UnassignTask";
    import TaskDetails from "../../../../components/jobTasks/Details";
    import RemoveUserFromTask from "../../../../components/users/RemoveUserFromTask";
    import Helpers from "../../../../utils/helpers/routeHelpers";

    export default {
        name: 'active-routes',
        components: {
            RemoveUserFromTask,
            ArchiveRoute,
            CompleteRoute,
            UnassignTask,
            RouteDetails,
            TaskDetails
        },
        created () {
            this.getRouteRange({keywords: '', limit: 10, offset: 0})
            this.getActiveCount()
        },
        data () {
            return {
                archiveDialog: false,
                routeDetails: false,
                taskDetailsDialog: false,
                removeTaskDialog: false,
                removeUserDialog: false,
                completeRouteDialog: false,
                selectedUser: null,
                routeForDetails: null,
                selectedDetailsTask: null,
                tableKey: 0,
                detailsType: '',
                search: '',

                options: {},
                displayRoutes: [],
                numDisplayRoutes: 0,
            }
        },
         methods: {
            ...mapActions({
                getIsolatedRoute: 'routes/getIsolatedRoute',
                selectRoute: 'routes/selectRoute',
                clearSelectedRoute: 'routes/clearSelectedRoute',
                completeTask: 'jobTasks/complete',
                completeRoute: 'routes/complete',
                getRouteRange: 'routes/getActiveRange',
                getActiveCount: 'routes/getActiveCount'
            }),
             async createRouteProcess () {
                 this.clearSelectedRoute()
                 let letters = "0123456789ABCDEF";
                 let color = '#';
                 for (let i = 0; i < 6; i++)
                     color += letters[(Math.floor(Math.random() * 16))];

                 let route = {
                    name: null,
                    id: null,
                    duration: '00:00:00',
                    color: color,
                    jobTasks: [],
                    userRoutes: [],
                }
                this.detailsType = 'create'
                this.selectRoute(route)
                this.toggleRouteDetails()
             },
             async removeTaskFromRoute (task) {
                 this.selectedDetailsTask = task
                 await this.toggleRemoveTaskDialog()
             },
             async removeUserFromTask (user) {
                this.selectedUser = user
                await this.toggleRemoveUserDialog()
             },
             toggleRemoveTaskDialog () {
                 this.removeTaskDialog = !(this.removeTaskDialog)
             },
             async updateTaskStatus (task) {
                 this.selectedDetailsTask = task
                 await this.toggleUpdateTaskStatus()
             },
             async editTaskDetails (task) {
                 this.selectedDetailsTask = task
                 await this.toggleTaskDetailsDialog()
             },
             toggleTaskDetailsDialog () {
                 this.taskDetailsDialog = !(this.taskDetailsDialog)
             },
             getCrewNames(route) {
                let members = []
                route.userRoutes.forEach(userRoute => {
                    members.push(userRoute.user.firstName)
                })
                return members.toString()
             },
             async completeRouteHandler(route) {
                 await this.selectRoute(route)
                 await this.toggleComplete()
             },
             async openRouteDetails(item) {
                this.getIsolatedRoute(item.id)
                this.detailsType = 'update'
                await this.toggleRouteDetails()
             },
             async archiveRoute(route) {
                 await this.selectRoute(route)
                 await this.toggleArchive()
             },
             toggleArchive () {
                 if(this.archiveDialog){
                     this.updateRows()
                 }
                this.archiveDialog = !(this.archiveDialog)
             },
             toggleRouteDetails () {
                 if(this.routeDetails){
                     this.updateRows()
                 }
                this.routeDetails = !(this.routeDetails)
             },
             toggleComplete() {
                 if(this.completeRouteDialog){
                     this.updateRows()
                 }
                 this.completeRouteDialog = !(this.completeRouteDialog)
             },
             toggleRemoveUserDialog () {
                 this.removeUserDialog = !(this.removeUserDialog)
             },
             updateRows(){
                 let limit = this.options.itemsPerPage
                 let offset = this.options.itemsPerPage * (this.options.page - 1)
                 //picking 'all' sets limit to -1 so we can handle that here
                 if(limit < 0){
                     limit = this.activeCount
                     offset = 0
                 }
                 this.getActiveCount()
                 this.getRouteRange({keywords: this.search, limit: limit, offset: offset})
             }
        },
        computed: {
            ...mapGetters({
                routeRange: 'routes/activeRange',
                selectedRoute: 'routes/selectedRoute',
                incompleteTasks: 'routes/selectedRouteIncompleteTasks',
                headers: 'routes/headers',
                error: 'routes/error',
                routeCount: 'routes/activeCount',

            }),
        },
        watch: {
            routeRange: function (routes) {
                if(!routes){
                    this.displayRoutes = []
                    this.numDisplayRoutes = 0
                    return
                }
                if (!Array.isArray(routes)) {
                    this.displayRoutes = [routes]
                } else {
                    this.displayRoutes = routes
                }
                //Check to see if any incomplete routes should be complete
                this.displayRoutes.forEach((route) => {
                    if(!route.complete && route.jobTasks.length > 0){
                        let completionStatus = true
                        route.jobTasks.forEach((jt) => {
                            completionStatus = completionStatus && (jt.status === 'Complete')
                        })
                        if(completionStatus){
                            route.complete = true
                            this.completeRoute(route.id)
                        }
                    }
                })
                this.displayRoutes.map(route => {
                    route.crew = Helpers.getCrewNames(route)
                    route.complete = Helpers.getCompletionStatus(route)
                })
                this.numDisplayRoutes = this.routeCount
            },
            options: {
                handler () {
                    this.updateRows()
                },
                deep: true,
            },
            routeCount: function (){
                this.numDisplayRoutes = this.routeCount
            }
        },

    }
</script>
